exports.install = function(Vue, options) {
    Vue.prototype.setCookie = function(name, value) {
        var Days = 30;
        var exp = new Date();
        exp.setTime(exp.getTime() + 1000 * 60 * 60 * 24 * 7); //过期时间 一周
        document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString();
    };
    Vue.prototype.getCookie = function(name) {
        var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
        if (arr = document.cookie.match(reg))
            return unescape(arr[2]);
        else
            return null;
    };
    Vue.prototype.deleteCookie = function($name) {
        var myDate = new Date();
        myDate.setTime(-1000); //设置时间
        document.cookie = $name + "=''; expires=" + myDate.toGMTString();
    };
    Vue.prototype.unixTimeTamp = function(time, type) {
        if (time) {
            return new Date(time).getFullYear() + '-' + ((new Date(time).getMonth() + 1) < 10 ? ("0" + (new Date(time).getMonth() + 1)) : ((new Date(time).getMonth()) + 1)) + '-' + ((new Date(time).getDate()) < 10 ? ("0" + (new Date(time).getDate())) : (new Date(time).getDate())) + " " + ((new Date(time).getHours()) < 10 ? ("0" + (new Date(time).getHours())) : (new Date(time).getHours())) + ":" + ((new Date(time).getMinutes()) < 10 ? ("0" + (new Date(time).getMinutes())) : (new Date(time).getMinutes())) + ":" + ((new Date(time).getSeconds()) < 10 ? ("0" + (new Date(time).getSeconds())) : (new Date(time).getSeconds()));
        } else {
            return "";
        }
    };
    Vue.prototype.newDate = function(time) {
        if (time) {
            return new Date(time).getFullYear() + '-' + ((new Date(time).getMonth() + 1) < 10 ? ("0" + (new Date(time).getMonth() + 1)) : ((new Date(time).getMonth()) + 1)) + '-' + ((new Date(time).getDate()) < 10 ? ("0" + (new Date(time).getDate())) : (new Date(time).getDate()))
        } else {
            return ''
        }

    };
    Vue.prototype.newDateTime = function(time) {
        if (time) {
            return ((new Date(time).getHours()) < 10 ? ("0" + (new Date(time).getHours())) : (new Date(time).getHours())) + ":" + ((new Date(time).getMinutes()) < 10 ? ("0" + (new Date(time).getMinutes())) : (new Date(time).getMinutes())) + ":" + ((new Date(time).getSeconds()) < 10 ? ("0" + (new Date(time).getSeconds())) : (new Date(time).getSeconds()))
        } else {
            return ''
        }
    };
    /*导出Excel*/
    Vue.prototype.getExcelBlob = function(content, name) {
        const blob = new Blob(["\uFEFF" + content], {
            type: "application/vnd.ms-excel;charset=charset=utf-8"
        })
        if ('download' in document.createElement('a')) { // 非IE下载 
            const elink = document.createElement('a')
            elink.download = name
            elink.style.display = 'none'
            elink.href = URL.createObjectURL(blob)
            document.body.appendChild(elink)
            elink.click()
            URL.revokeObjectURL(elink.href) // 释放URL 对象 
            document.body.removeChild(elink)
        } else { // IE10+下载 
            navigator.msSaveBlob(blob, fileName)
        }
    }
}


// WEBPACK FOOTER //
// ./src/common/js/public.js